import { Injectable } from '@angular/core';

import { getClazz, getJsonProperty } from './json-metadata';

// see http://cloudmark.github.io/Json-Mapping/
/// <reference path='../../../../node_modules/reflect-metadata/reflect-metadata.d.ts'/>

@Injectable({
  providedIn: 'root',
})
export class ObjectMapperService {
  // tip see https://github.com/Microsoft/TypeScript/issues/2794
  // static deserialize<T>(clazz: {new(): T}, jsonObject: any): T[] {
  public deserialize<T>(clazz: { new (...args: any[]): T }, jsonObject: any): T {
    if (clazz === undefined || jsonObject === undefined) {
      return;
    }
    const obj = new clazz();
    Object.keys(obj).forEach(key => {
      const propertyMetadataFn: (IJsonMetaData: any) => any = propertyMetadata => {
        const propertyName = propertyMetadata.name || key;
        const innerJson = jsonObject ? jsonObject[propertyName] : undefined;
        const clazzInner = getClazz(obj, key);
        if (this.isArray(clazzInner)) {
          const metadata = getJsonProperty(obj, key);
          if (metadata.clazz || this.isPrimitive(clazzInner)) {
            return innerJson && this.isArray(innerJson)
              ? innerJson.map((item: any) => this.deserialize(metadata.clazz, item))
              : undefined;
          } else {
            return innerJson;
          }
        } else if (this.isPrimitive(clazzInner)) {
          return jsonObject ? jsonObject[propertyName] : undefined;
        } else {
          return this.deserialize(clazzInner, innerJson);
        }
      };

      const propertyMetadata = getJsonProperty(obj, key);
      if (propertyMetadata) {
        obj[key] = propertyMetadataFn(propertyMetadata);
      } else {
        if (jsonObject && jsonObject[key] !== undefined) {
          obj[key] = jsonObject[key];
        }
      }
    });
    return obj;
  }

  private isPrimitive(obj: any): boolean {
    switch (typeof obj) {
      case 'string':
      case 'number':
      case 'boolean': {
        return true;
      }
      default: {
        return !!(
          obj instanceof String ||
          obj === String ||
          obj instanceof Number ||
          obj === Number ||
          obj instanceof Boolean ||
          obj === Boolean
        );
      }
    }
  }

  private isArray(object: any): boolean {
    if (object === Array) {
      return true;
    } else if (typeof Array.isArray === 'function') {
      return Array.isArray(object);
    } else {
      return !!Array.isArray(object);
    }
  }
}
